@let newMode = isNewMode();
@let anexMode = isAnexMode();
<div class="container">
  <form [formGroup]="formGroup" (ngSubmit)="handleSubmit()">
    <app-request-title></app-request-title>

    <app-workspace-state
      [workspaceStateDraftVersion]="workspaceStateDraftVersion"
      [workspaceStateId]="workspaceStateId"
      [getWorkspaceStateToSave]="getWorkspaceStateToSave"
      [workspaceStateSaveValidator]="
        validateIfRequestModeIsSelectedAndShowAlert
      "
      [workspaceStateLoadValidator]="
        validateIfRequestModeIsSelectedAndShowAlert
      "
      [requestMode]="getRequestModeValue()"
      [buttonClass]="'btn-outline-primary'"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
      (workspaceStateLoaded)="handleLoadWorkspaceResponse($event)"
    ></app-workspace-state>

    @let investorDetailsFormGroupAlertShouldBeVisible =
      submitted && !isInvestorDetailsFormGroupValid();
    <section>
      <div
        class="card mb-4"
        [ngClass]="
          investorDetailsFormGroupAlertShouldBeVisible
            ? 'border-danger border-2'
            : 'card-border-color-from-db'
        "
      >
        <div class="card-header card-header-color-from-db">
          {{ 'PROPERTY_LEASE.CLIENT_DATA' | translate }}
        </div>

        <div class="card-body">
          <app-investor-details
            [investorDetailsFromGroup]="getInvestorDetailsFormGroup()"
            [isEmailRequired]="false"
            [isEPUAPAddressVisible]="true"
            [isPeselVisible]="false"
            [isIdVisible]="false"
            [isPhoneNumberRequired]="false"
            [disabledNaturalPersonData]="true"
            [wasFormValidated]="submitted"
            [loggedUserAddressEditableByExternalForm]="true"
          ></app-investor-details>
        </div>

        @if (investorDetailsFormGroupAlertShouldBeVisible) {
          <div class="card-footer">
            <div class="alert alert-danger my-2">
              {{ 'FIELDS_REQUIRED' | translate }}
            </div>
          </div>
        }
      </div>
    </section>

    <gk-request-mode
      #requestModeComponent
      [formGroup]="formGroup"
      [portalId]="portalId"
      [submitted]="submitted"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
    ></gk-request-mode>

    @if (newMode) {
      <section>
        <div class="card mb-4 card-border-color-from-db">
          <div class="card-header card-header-color-from-db">
            {{ 'PROPERTY_LEASE.LOCATION' | translate }}
          </div>

          <div class="card-body">
            <div class="mb-2">
              <label class="text-nowrap" [attr.for]="controlName.Place">
                {{ 'PROPERTY_LEASE.PLACE' | translate }}
              </label>

              <input
                type="text"
                [name]="controlName.Place"
                [id]="controlName.Place"
                class="form-control form-control-sm required"
                aria-required="true"
                [formControlName]="controlName.Place"
                [ngbTypeahead]="searchPlace"
                [resultFormatter]="formatter"
                [inputFormatter]="formatter"
                (focusout)="setPlaceByName()"
              />

              @if (shouldShowRequiredAlert(getPlaceFormControl())) {
                <div class="alert alert-danger">
                  {{ 'FIELD_REQUIRED' | translate }}
                </div>
              }
            </div>

            <div class="mb-2">
              <label class="text-nowrap" [attr.for]="controlName.Street">
                {{ 'PROPERTY_LEASE.STREET' | translate }}
              </label>

              <input
                type="text"
                [name]="controlName.Street"
                [id]="controlName.Street"
                class="form-control form-control-sm"
                [ngbTypeahead]="searchStreet"
                [resultFormatter]="formatter"
                [inputFormatter]="formatter"
                [formControlName]="controlName.Street"
                (focusout)="setStreetByName()"
                [autocomplete]="undefined"
              />
            </div>
          </div>
        </div>
      </section>

      <section>
        <div
          class="card mb-4"
          [ngClass]="
            !areAreaFormControlsValid() && submitted
              ? 'border-danger border-2'
              : 'card-border-color-from-db'
          "
        >
          <div class="card-header card-header-color-from-db">
            {{ 'PROPERTY_LEASE.AREA_TITLE' | translate }}
          </div>

          <div class="card-body">
            <gk-map
              [mapState]="mapState"
              (dispatch)="handleMapAction($event)"
            ></gk-map>

            <div class="my-2">
              @if (mapState.mapObjectTablesState[0].mapObjects.length) {
                <gk-map-object-table
                  [mapState]="mapState"
                  [mapObjectTableStateIndex]="0"
                  (dispatch)="handleMapAction($event)"
                ></gk-map-object-table>
              }
            </div>

            <div class="mb-2 row">
              <div class="col-auto pe-0">
                <label class="text-nowrap" [attr.for]="controlName.AreaToLease">
                  {{ 'PROPERTY_LEASE.AREA' | translate }}
                </label>
              </div>

              <div class="col-auto ps-0">
                <div class="input-group input-group-sm ps-2">
                  <input
                    type="number"
                    [name]="controlName.AreaToLease"
                    [id]="controlName.AreaToLease"
                    class="form-control required"
                    aria-required="true"
                    [formControlName]="controlName.AreaToLease"
                  />

                  <span class="input-group-text">m²</span>
                </div>
              </div>
            </div>
          </div>

          @if (submitted && !areAreaFormControlsValid()) {
            <div class="card-footer">
              @if (!areLandParcelsChosen()) {
                <div class="alert alert-danger mt-2">
                  {{ 'PROPERTY_LEASE.LAND_PARCEL_REQUIRED' | translate }}
                </div>
              }
              @if (!isAreaFormControlValid()) {
                <div class="alert alert-danger mt-2">
                  {{ 'PROPERTY_LEASE.AREA_REQUIRED' | translate }}
                </div>
              }
            </div>
          }
        </div>
      </section>

      <section>
        <div
          class="card mb-4"
          [ngClass]="
            !isPurposeFormControlValid() && submitted
              ? 'border-danger border-2'
              : 'card-border-color-from-db'
          "
        >
          <div class="card-header card-header-color-from-db">
            <label class="mb-0" [attr.for]="controlName.Purpose">
              {{ 'PROPERTY_LEASE.PURPOSE' | translate }}
            </label>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <textarea
                  [name]="controlName.Purpose"
                  [id]="controlName.Purpose"
                  class="form-control form-control-sm required"
                  aria-required="true"
                  [formControlName]="controlName.Purpose"
                ></textarea>
              </div>
            </div>
          </div>

          @if (!isPurposeFormControlValid() && submitted) {
            <div class="card-footer">
              <div class="alert alert-danger">
                {{ 'FIELD_REQUIRED' | translate }}
              </div>
            </div>
          }
        </div>
      </section>

      @let dateRangeFormControlAlertShouldBeVisible =
        submitted && isDateRangeInvalid();
      <section>
        <div
          class="card mb-4"
          [ngClass]="
            dateRangeFormControlAlertShouldBeVisible
              ? 'border-danger border-2'
              : 'card-border-color-from-db'
          "
        >
          <div class="card-header card-header-color-from-db">
            <label class="mb-0" [attr.for]="controlName.LeaseDate">
              {{ 'PROPERTY_LEASE.LEASE_DATE' | translate }}
            </label>
          </div>

          <div class="card-body">
            <app-date-range-picker
              #leaseDateRangeComponent
              (dateRangeChanged)="updateDateRangeFormControl($event)"
              [required]="true"
            ></app-date-range-picker>
          </div>

          @if (dateRangeFormControlAlertShouldBeVisible) {
            <div class="card-footer">
              <div class="alert alert-danger">
                {{ 'PERIOD_INVALID' | translate }}
              </div>
            </div>
          }
        </div>
      </section>
    }

    @if (anexMode) {
      @let leaseNumberFormControlAlertShouldBeVisible =
        submitted && !isLeaseNumberFormControlValid();
      <section>
        <div
          class="card mb-4"
          [ngClass]="
            leaseNumberFormControlAlertShouldBeVisible
              ? 'border-danger border-2'
              : 'card-border-color-from-db'
          "
        >
          <div class="card-header card-header-color-from-db">
            <label class="mb-0" [attr.for]="controlName.LeaseNumber">
              {{ 'PROPERTY_LEASE.LEASE_NUMBER' | translate }}
            </label>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <input
                  type="text"
                  [name]="controlName.LeaseNumber"
                  [id]="controlName.LeaseNumber"
                  class="form-control form-control-sm required"
                  aria-required="true"
                  [formControlName]="controlName.LeaseNumber"
                />
              </div>
            </div>
          </div>

          @if (leaseNumberFormControlAlertShouldBeVisible) {
            <div class="card-footer">
              <div class="alert alert-danger my-2">
                {{ 'FIELD_REQUIRED' | translate }}
              </div>
            </div>
          }
        </div>
      </section>

      @let anexDescriptionFormControlAlertShouldBeVisible =
        submitted && !isAnexDescriptionFormControlValid();
      <section>
        <div
          class="card mb-4"
          [ngClass]="
            anexDescriptionFormControlAlertShouldBeVisible
              ? 'border-danger border-2'
              : 'card-border-color-from-db'
          "
        >
          <div class="card-header card-header-color-from-db">
            <label class="mb-0" [attr.for]="controlName.AnexDescription">
              {{ 'PROPERTY_LEASE.ANEX_DESCRIPTION' | translate }}
            </label>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <textarea
                  [name]="controlName.AnexDescription"
                  [id]="controlName.AnexDescription"
                  class="form-control form-control-sm required"
                  aria-required="true"
                  [formControlName]="controlName.AnexDescription"
                ></textarea>
              </div>
            </div>
          </div>

          @if (anexDescriptionFormControlAlertShouldBeVisible) {
            <div class="card-footer">
              <div class="alert alert-danger my-2">
                {{ 'FIELD_REQUIRED' | translate }}
              </div>
            </div>
          }
        </div>
      </section>

      @let anexDateFormFormControlAlertShouldBeVisible =
        submitted && !isAnexDateFromFormControlValid();
      <section>
        <div
          class="card mb-4"
          [ngClass]="
            anexDateFormFormControlAlertShouldBeVisible
              ? 'border-danger border-2'
              : 'card-border-color-from-db'
          "
        >
          <div class="card-header card-header-color-from-db">
            <label class="mb-0" [attr.for]="controlName.AnexDateFrom">
              {{ 'PROPERTY_LEASE.ANEX_DATE_FROM' | translate }}
            </label>
          </div>

          <div class="card-body">
            <div class="input-group">
              <input
                class="form-control form-control-sm required"
                [attr.placeholder]="
                  'GK.DYNAMIC_LIST.DATE_PLACEHOLDER' | translate
                "
                [id]="controlName.AnexDateFrom"
                [name]="controlName.AnexDateFrom"
                [formControlName]="controlName.AnexDateFrom"
                ngbDatepicker
                #anexDateFromDatePicker="ngbDatepicker"
              />
              <button
                class="btn btn-outline-secondary fa fa-calendar"
                (click)="anexDateFromDatePicker.toggle()"
                type="button"
              ></button>
            </div>
          </div>

          @if (anexDateFormFormControlAlertShouldBeVisible) {
            <div class="card-footer">
              <div class="alert alert-danger my-2">
                {{ 'FIELD_REQUIRED' | translate }}
              </div>
            </div>
          }
        </div>
      </section>
    }

    <app-proxy-details
      #proxyDetails
      [portalId]="portalId"
      [formGroup]="formGroup"
      [submitted]="submitted"
      [addressFormGroupBasedOnSelectControls]="true"
      [multiple]="true"
      [proxyTypeFormControlVisible]="true"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
    ></app-proxy-details>

    <gk-attachments
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
      [portalId]="portalId"
      [submitted]="submitted"
      [requiredPowerOfAttorney]="proxyDetails.detailsVisible"
      [requiredRequestMode]="true"
      [requestMode]="getRequestModeValue()"
    >
    </gk-attachments>

    <app-request-reply-form
      [portalId]="portalId"
      [formGroup]="formGroup"
      [submitted]="submitted"
      [borderClass]="'card-border-color-from-db'"
      [backgroundClass]="'card-header-color-from-db'"
      [buttonClass]="'btn-color-from-db'"
    ></app-request-reply-form>

    @if (newMode) {
      <section>
        <div class="card mb-4 card-border-color-from-db">
          <div class="card-header card-header-color-from-db">
            <label class="mb-0" [attr.for]="controlName.Comments">
              {{ 'PROPERTY_LEASE.ADDITIONAL_INFORMATION' | translate }}
            </label>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <textarea
                  [name]="controlName.Comments"
                  [id]="controlName.Comments"
                  class="form-control form-control-sm"
                  [formControlName]="controlName.Comments"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </section>
    }

    <section class="my-2">
      <app-cautions
        [portalId]="portalId"
        [formGroup]="formGroup"
        [submitted]="submitted"
        [buttonClass]="'btn-color-from-db'"
        [borderClass]="'card-border-color-from-db'"
        [backgroundClass]="'card-header-color-from-db'"
      ></app-cautions>
    </section>

    <app-request-validation-info
      [shouldShowProvideFieldsAlert]="submitted && !isRequestValid()"
      [errorSubmitMessage]="errorSubmitMessage"
    ></app-request-validation-info>

    <section>
      <button type="submit" class="btn btn-color-from-db">
        {{ 'PROPERTY_LEASE.SUBMIT' | translate }}
      </button>

      <app-request-preview-button
        class="ms-2"
        [buttonClass]="'btn-color-from-db'"
        [getPreviewRequestBody]="getRequestBody"
        [previewRequestUrl]="
          '/api/interesant/wniosek/wydzierzawienieNieruchomosci/podglad'
        "
        [previewRequestValidation]="validateIfRequestModeIsSelectedAndShowAlert"
      ></app-request-preview-button>

      <app-request-cancel-button></app-request-cancel-button>

      <app-doc-sign-info
        [messageText]="docSignMsgTxt"
        [messageType]="docSignMsgType"
        [docSignUrl]="docSignUrl"
        [docSignPending]="docSignPending"
      ></app-doc-sign-info>

      <div class="mt-2"><app-form-legend></app-form-legend></div>
    </section>
  </form>
</div>

<ng-template #canDeactivateModal let-close="close">
  <div class="modal-header">
    <h4 class="modal-title">
      {{ 'MODAL_CAN_DEACTIVATE.ALERT_TITLE' | translate }}
    </h4>
  </div>

  <div class="modal-body">
    {{ 'MODAL_CAN_DEACTIVATE.DESCRIPTION' | translate }}
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="close(false)">
      {{ 'MODAL_CAN_DEACTIVATE.CANCEL' | translate }}
    </button>

    <button type="button" class="btn btn-primary" (click)="close(true)">
      {{ 'MODAL_CAN_DEACTIVATE.CONFIRM' | translate }}
    </button>
  </div>
</ng-template>
